import { Box, HStack, Heading, Stack, VStack } from '@chakra-ui/react'
import React from 'react' 
import {TiSocialYoutubeCircular,TiSocialInstagramCircular} from 'react-icons/ti'
import {DiGithub} from 'react-icons/di'
import { Link } from 'react-router-dom'
const Footer = () => {
  return (
    <Box padding={'4'} bg='blackAlpha.900' minH={'10vh'}>
      <Stack direction={['column','row']}>
        <VStack alignItems={['center','flex-start']} width='full'>
          <Heading children="All Rights Reserved" color={'white'} />
          <Heading children="Sahil Tiwari" color={'yellow.400'} fontFamily={'body'} size='sm' />

        </VStack>
<HStack spacing={['2','10']} justifyContent='center' color={'white'} fontSize='50'>
<Link to='' target={'_blank'}>
<TiSocialYoutubeCircular/>
</Link>
<Link to='https://www.instagram.com/sahiltiwari2936/' target={'_blank'}>
<TiSocialInstagramCircular/>
</Link>
<Link to='https://github.com/sahilTiwariiii' target={'_blank'}>
<DiGithub/>
</Link>
</HStack>
      </Stack>
      
    </Box>
  )
}

export default Footer